module.exports = __webpack_public_path__ + "static/media/S (117).ea17c5ad.jpg";